module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-257.43f0efe2.svg";